<div class="row justify-content-center">
  <div class="col-21 col-l-13">
    <sd-seo [data]="data" [brand]="brand" />
  </div>
</div>
